import React from 'react';
import { OverlayView } from '@react-google-maps/api';

import { RoundMarkerProps } from './types';
import { RoundBox, MarkerTooltip } from './styles';

import { getPixelPositionOffset } from '../Marker/utils';

const RoundMarker: React.FunctionComponent<RoundMarkerProps> = ({ location, icon, roundColor, tooltipTitle, open }) => (
  <OverlayView
    mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
    position={location}
    getPixelPositionOffset={getPixelPositionOffset}
  >
    <MarkerTooltip placement="right" open={open} title={tooltipTitle}>
      <RoundBox $roundColor={roundColor}>{icon}</RoundBox>
    </MarkerTooltip>
  </OverlayView>
);

export default RoundMarker;
